import React from 'react';
import { InputElementBase } from '../utils/types';
import FormInput from './FormInput';
import { usStates, canadianProvincesAndTerritories } from '@/data/constants';
import { SelectInput } from './SelectInput';
import { hasProvinces } from '@/lib/utils';
import { copy } from '@/data/copy';

type StateProvinceRenderer = {
  selectedCountry: string;
  field: InputElementBase;
};

export default function StateProvinceRenderer({
  selectedCountry,
  field,
}: StateProvinceRenderer) {
  if (hasProvinces(selectedCountry)) {
    if (selectedCountry === 'Canada') {
      return (
        <SelectInput
          label={copy.common.form.province}
          placeholder={`${copy.common.form.selectAProvince}`}
          selectOptions={canadianProvincesAndTerritories}
          {...field}
        />
      );
    }

    return (
      <FormInput
        label={copy.common.form.province}
        placeholder={`${copy.common.form.selectAProvince}`}
        {...field}
      />
    );
  } else {
    if (selectedCountry === 'United States') {
      return (
        <SelectInput
          label={copy.common.form.state}
          placeholder={`${copy.common.form.selectAState}`}
          selectOptions={usStates}
          {...field}
        />
      );
    }

    return (
      <FormInput
        label={copy.common.form.state}
        placeholder={`${copy.common.form.selectAState}`}
        {...field}
      />
    );
  }
}
